import { AlertCircle } from 'lucide-react';

export default function ErrorMessage({ message = 'Une erreur est survenue. Veuillez réessayer.' }) {
  return (
    <div className="rounded-xl border border-verdict-danger-border bg-verdict-danger-bg p-4 flex gap-3 text-verdict-danger">
      <AlertCircle className="w-5 h-5 flex-shrink-0" />
      <p className="text-sm leading-relaxed">{message}</p>
    </div>
  );
}
